import React from 'react'
import { Container } from 'react-bootstrap'
import QuestionsImg from '../assets/images/questions-cta-img.svg'
function QuestionsCTA() {
  return (
    <>
     <div className="questions-cta common-padding">
      <Container>
        <div className='questions-cta-wrap'>
          <img src={QuestionsImg} alt="" />
          <div className='text-wrap'>
            <h2>Questions?</h2>
            <p>Check out our Frequently Asked Questions or give us a call at (833) 924-2739</p>
          </div>
        </div>
      </Container>
     </div>
    </>
  )
}
export default QuestionsCTA